(() => {
  const GALLERY_SELECTOR = 'media-gallery';
  const GRID_SELECTOR = '.media-gallery__grid';
  const STYLE_ID = 'jugre-product-gallery-fix';
  const STYLE_CONTENT = `
    media-gallery .variant-media-filter__nav,
    media-gallery .variant-media-filter__thumbs {
      display: none !important;
    }

    media-gallery.jugre-gallery-fixed slideshow-component {
      display: none !important;
    }

    media-gallery.jugre-gallery-fixed .media-gallery__grid {
      display: flex !important;
      flex-wrap: nowrap !important;
      gap: 0 !important;
      grid-template-columns: none !important;
      margin: 0;
      overflow-x: auto;
      overflow-y: hidden;
      padding: 0;
      scroll-behavior: smooth;
      scroll-snap-type: x mandatory;
      scrollbar-width: none;
    }

    media-gallery.jugre-gallery-fixed .media-gallery__grid::-webkit-scrollbar {
      display: none;
    }

    media-gallery.jugre-gallery-fixed .media-gallery__grid > .product-media-container {
      display: block !important;
      flex: 0 0 100% !important;
      margin: 0 !important;
      max-width: 100% !important;
      min-width: 100% !important;
      scroll-snap-align: start;
      width: 100% !important;
    }

    media-gallery.jugre-gallery-fixed .product-media-container.constrain-height {
      align-items: stretch;
    }

    media-gallery.jugre-gallery-fixed .product-media,
    media-gallery.jugre-gallery-fixed .product-media > * {
      width: 100%;
    }

    media-gallery.jugre-gallery-fixed .product-media {
      min-height: clamp(320px, 44vw, 720px);
    }

    media-gallery.jugre-gallery-fixed .product-media__image,
    media-gallery.jugre-gallery-fixed .deferred-media__poster-image {
      background: var(--color-background);
      display: block;
      height: 100%;
      object-fit: contain !important;
      width: 100%;
    }

    media-gallery.jugre-gallery-fixed .product-media-container--image .product-media {
      aspect-ratio: auto;
    }

    media-gallery.jugre-gallery-fixed .jugre-gallery-controls {
      align-items: center;
      display: flex;
      gap: 12px;
      justify-content: center;
      margin-top: 14px;
    }

    media-gallery.jugre-gallery-fixed .jugre-gallery-arrow {
      align-items: center;
      background: rgb(var(--color-background-rgb, 255 255 255));
      border: 1px solid rgba(0, 0, 0, 0.14);
      border-radius: 999px;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
      cursor: pointer;
      display: inline-flex;
      font-size: 18px;
      height: 40px;
      justify-content: center;
      line-height: 1;
      width: 40px;
    }

    media-gallery.jugre-gallery-fixed .jugre-gallery-arrow[disabled] {
      cursor: default;
      opacity: 0.35;
    }

    media-gallery.jugre-gallery-fixed .jugre-gallery-dots {
      align-items: center;
      display: flex;
      gap: 8px;
      justify-content: center;
    }

    media-gallery.jugre-gallery-fixed .jugre-gallery-dot {
      background: transparent;
      border: 1px solid rgba(0, 0, 0, 0.35);
      border-radius: 999px;
      cursor: pointer;
      height: 10px;
      padding: 0;
      width: 10px;
    }

    media-gallery.jugre-gallery-fixed .jugre-gallery-dot[aria-current='true'] {
      background: #111;
      border-color: #111;
    }

    @media screen and (max-width: 749px) {
      media-gallery.jugre-gallery-fixed .product-media {
        min-height: clamp(260px, 72vw, 520px);
      }

      media-gallery.jugre-gallery-fixed .jugre-gallery-controls {
        gap: 10px;
        margin-top: 10px;
      }

      media-gallery.jugre-gallery-fixed .jugre-gallery-arrow {
        height: 36px;
        width: 36px;
      }
    }
  `;

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = STYLE_CONTENT;
    document.head.appendChild(style);
  }

  function clampIndex(index, total) {
    if (total <= 0) return 0;
    if (index < 0) return 0;
    if (index > total - 1) return total - 1;
    return index;
  }

  function getItems(grid) {
    return Array.from(grid.querySelectorAll(':scope > .product-media-container'));
  }

  function unhideAllItems(items) {
    items.forEach((item) => {
      item.hidden = false;
      item.style.display = '';
      item.dataset.variantMediaHidden = 'false';
    });
  }

  function ensureControls(gallery) {
    let controls = gallery.querySelector('.jugre-gallery-controls');
    if (controls) return controls;

    controls = document.createElement('div');
    controls.className = 'jugre-gallery-controls';
    controls.innerHTML =
      '<button type="button" class="jugre-gallery-arrow" data-dir="-1" aria-label="Previous image">‹</button>' +
      '<div class="jugre-gallery-dots" aria-label="Image pagination"></div>' +
      '<button type="button" class="jugre-gallery-arrow" data-dir="1" aria-label="Next image">›</button>';
    gallery.appendChild(controls);
    return controls;
  }

  function updateControls(gallery, index, total) {
    const controls = gallery.querySelector('.jugre-gallery-controls');
    if (!controls) return;

    const prev = controls.querySelector('[data-dir="-1"]');
    const next = controls.querySelector('[data-dir="1"]');
    const dots = controls.querySelectorAll('.jugre-gallery-dot');

    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index >= total - 1;

    dots.forEach((dot, dotIndex) => {
      dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
    });
  }

  function renderDots(gallery, total, onSelect) {
    const controls = ensureControls(gallery);
    const dots = controls.querySelector('.jugre-gallery-dots');
    if (!dots) return;

    dots.innerHTML = '';
    for (let index = 0; index < total; index += 1) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'jugre-gallery-dot';
      dot.setAttribute('aria-label', `Go to image ${index + 1}`);
      dot.addEventListener('click', () => onSelect(index));
      dots.appendChild(dot);
    }
  }

  function bindGallery(gallery) {
    if (gallery.dataset.jugreGalleryBound === 'true') return;

    const grid = gallery.querySelector(GRID_SELECTOR);
    if (!grid) return;

    const items = getItems(grid);
    if (!items.length) return;

    gallery.dataset.jugreGalleryBound = 'true';
    gallery.classList.add('jugre-gallery-fixed');

    const nativeSlideshow = gallery.querySelector('slideshow-component');
    if (nativeSlideshow) nativeSlideshow.setAttribute('aria-hidden', 'true');

    unhideAllItems(items);

    let currentIndex = 0;
    let ticking = false;

    const showSlide = (nextIndex, behavior = 'smooth') => {
      currentIndex = clampIndex(nextIndex, items.length);
      items[currentIndex].scrollIntoView({
        behavior,
        block: 'nearest',
        inline: 'start',
      });
      updateControls(gallery, currentIndex, items.length);
    };

    if (items.length > 1) {
      renderDots(gallery, items.length, (index) => showSlide(index));
      const controls = ensureControls(gallery);
      controls.addEventListener('click', (event) => {
        const button = event.target.closest('[data-dir]');
        if (!button) return;
        const direction = Number(button.getAttribute('data-dir') || '0');
        showSlide(currentIndex + direction);
      });
      updateControls(gallery, currentIndex, items.length);
    }

    grid.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          ticking = false;
          const gridLeft = grid.getBoundingClientRect().left;
          let bestIndex = currentIndex;
          let bestDistance = Number.POSITIVE_INFINITY;

          items.forEach((item, index) => {
            const distance = Math.abs(item.getBoundingClientRect().left - gridLeft);
            if (distance < bestDistance) {
              bestDistance = distance;
              bestIndex = index;
            }
          });

          if (bestIndex !== currentIndex) {
            currentIndex = bestIndex;
            updateControls(gallery, currentIndex, items.length);
          }
        });
      },
      { passive: true }
    );
  }

  function boot() {
    ensureStyles();
    document.querySelectorAll(GALLERY_SELECTOR).forEach(bindGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
